import React from 'react';

import { Box, Button, Typography } from '@mui/material';

import { Field, Form } from '@hrlogics/react-components/form';

import {
  DASHBOARD_CV_ADMIN_CUSTOM_FILTER_AUTOCOMPLETE_PROPS,
  DashboardFilterCVAdminCustomFormFields,
} from './constants';
import { DashboardFilterCVAdminAutocomplete } from './DashboardFilterCVAdminAutocomplete';
import { DashboardFilterCVAdminCustomFormValues } from './types';

type DashboardFilterCVAdminCustomForm = {
  onSubmit: (customFilters: DashboardFilterCVAdminCustomFormValues) => void;
  onClose: () => void;
  initialValues: DashboardFilterCVAdminCustomFormValues;
};

export const DashboardFilterCVAdminCustomForm: React.FC<DashboardFilterCVAdminCustomForm> = ({
  onSubmit,
  onClose,
  initialValues,
}) => {
  const handleSubmit = React.useCallback(
    (values: DashboardFilterCVAdminCustomFormValues) => {
      onSubmit(values);
      onClose();
    },
    [onSubmit, onClose],
  );

  return (
    <Form<DashboardFilterCVAdminCustomFormValues>
      onSubmit={handleSubmit}
      initialValues={initialValues}
      subscription={{ valid: true, submitting: true }}
    >
      {({ valid, submitting }) => (
        <Box p={3} pt={5} width={750}>
          <Typography variant="subtitle1">Select Filters</Typography>

          <Typography variant="body1" mt={1} color="text.secondary">
            Use these filters to get information about specific Employer / PEO statistics
          </Typography>

          <Box display="flex" flexDirection="row" mt={2} gap={2} alignItems="center">
            <Field
              component={DashboardFilterCVAdminAutocomplete}
              name={`${DashboardFilterCVAdminCustomFormFields.filters}.employer`}
              width="100%"
              disabled={submitting}
              label="Employer"
              {...DASHBOARD_CV_ADMIN_CUSTOM_FILTER_AUTOCOMPLETE_PROPS.Employer}
            />
            OR
            <Field
              component={DashboardFilterCVAdminAutocomplete}
              name={`${DashboardFilterCVAdminCustomFormFields.filters}.PEO`}
              width="100%"
              disabled={submitting}
              label="Peo"
              {...DASHBOARD_CV_ADMIN_CUSTOM_FILTER_AUTOCOMPLETE_PROPS.PEO}
            />
          </Box>

          <Box display="flex" flexDirection="row" justifyContent="flex-end" gap={1.25} mt={2}>
            <Button color="secondary" onClick={onClose} disabled={submitting}>
              Cancel
            </Button>
            <Button type="submit" disabled={!valid || submitting}>
              Apply
            </Button>
          </Box>
        </Box>
      )}
    </Form>
  );
};
